import { useState } from "react";
import {
  Button,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { useTranslation } from "react-i18next";

export default function BtnAdd({ name, mana, manaName, onGaugeUpdate }) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [change, setChange] = useState("");

  const handleValid = () => {
    const n = parseInt(change);
    if (!isNaN(n) && n > 0) {
      onGaugeUpdate?.(manaName, mana + n);
    }
    setChange("");
    setOpen(false);
  };

  return (
    <>
      <Button
        onClick={() => setOpen(true)}
        sx={{ color: "inherit", minWidth: "auto", p: "2px" }}
      >
        <AddCircleOutlineIcon />
      </Button>
      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>{t("btn.gainTitle")}</DialogTitle>
        <DialogContent>
          <DialogContentText>{t("btn.pointsGained", { name })}</DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            label={t("btn.pointsGainedLabel")}
            type="number"
            fullWidth
            variant="standard"
            value={change}
            onChange={(e) => setChange(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && handleValid()}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleValid}>{t("common.validate")}</Button>
          <Button onClick={() => setOpen(false)}>{t("common.cancelBtn")}</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
